"use strict";
var _ = require("underscore");

module.exports.parseQueryStringToObject = function(queryString){
  var queryStringObject = {};

  if (queryString == null) {
    return queryStringObject;
  }

  var queryStringParams = queryString.replace("?","").split("&");

  var isQueryStringEmpty = queryStringParams[0] !== "";

  if (isQueryStringEmpty) {
    for (var i = 0; i < queryStringParams.length; i++) {
      var params = queryStringParams[i].split("=");
      var key = params[0];
      var value = params[1];
      var isValueArray = /\[.*\]/.test(value);
      var isValueBoolean = /true|false/.test(value);

      if (isValueArray) {
        queryStringObject[key] = JSON.parse(value);
      } else if (isValueBoolean) {
        queryStringObject[key] = JSON.parse(value);
      }else {
        queryStringObject[key] = value;
      }
    }
  }

  return queryStringObject;
};

module.exports.getPageEnv = function(winLocation){
  if (winLocation == null) {
    return null;
  }
  var env = 'activities';
  if (winLocation.href.indexOf("/empresas") !=- 1) { env = "organization"; }
  else if(winLocation.href.indexOf("/pessoas") !=- 1) { env = "person"; }
  else if(winLocation.href.indexOf("/negocios") !=- 1) { env = "deal"; }
  else if(winLocation.href.indexOf("/tarefas") !=- 1) { env = "task"; }
  return env;
};

module.exports.getEntityId = function(queryString){
  if (queryString == null) {
    return null;
  }
  var matchEntityId = queryString.match(/(?:\?id=)(\d*)/);
  return matchEntityId ? matchEntityId[1] : null;
};



// WEBPACK FOOTER //
// ./app/util/browser/url.js